<template>
  <div class="big">
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <!-- 选择商品 -->
        <ChooseGood
          v-if="chooseGoodShow"
          @close="chooseGoodShow = false"
          @checkGoods="checkGoods"
        ></ChooseGood>
        <div class="topbpx">
          <el-button
            type="primary"
            style="width:120px"
            @click="chooseGoodShow = true"
            :disabled="
            module_id_array[0] ? !module_id_array.includes('896') : false
          "
          >选择商品</el-button>
          <span class="title">说明：</span>
          <span>该规则可无条件推荐商品，任何情况均展示选择的商品</span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >

            <el-table-column
              label="排序"
              width="120"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.sort"
                  step-strictly
                  :step="1"
                  :min="0"
                  :max="9999999999"
                  :controls="false"
                  style="width:80px"
                  @change="setSort(scope.row.recommend_goods_id,scope.row.sort)"
                  :disabled="module_id_array[0]?!module_id_array.includes('894'):false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              label="商品"
              width="300"
            >
              <template slot-scope="scope">
                <div class="flex align-center">
                  <img
                    :src="scope.row.picture"
                    alt
                    style="width: 100px; height: auto; margin-right: 15px"
                  />
                  <div>
                    <div>
                      {{ scope.row.goods_name }}
                    </div>
                    <div
                      class="outstate"
                      v-if="scope.row.state==1||scope.row.state==10||scope.row.state==5||scope.row.state==6"
                    >
                      已下架
                    </div>
                  </div>

                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="规格"
              prop="sku_name"
            >
            </el-table-column>
            <el-table-column
              label="商品价格"
              prop="new_price"
            >
            </el-table-column>
            <el-table-column
              label="活动价"
              prop="activity_price"
            >
              <template slot-scope="scope">
                <div>{{scope.row.activity_price?scope.row.activity_price:"无"}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="销量"
              prop="real_sales"
            >
            </el-table-column>
            <el-table-column
              label="库存"
              prop="stock"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="80"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="delGoods(scope.row.recommend_goods_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('895')
                      : false
                  "
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import ChooseGood from './ChooseGood';

export default {
  data() {
    return {
      tableData: [],
      chooseGoodShow: false,
      goods_list: []
    };
  },
  components: {
    ChooseGood
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    getList() {
      let data = {
        page: 1,
        pageNumber: 100
      };
      this.axios
        .post('platform/shop/getDirectRecommenLists', data)
        .then((res) => {
          this.tableData = res.data.list;
        })
        .catch((err) => {});
    },
    //修改排序
    setSort(recommend_goods_id, sort) {
      let data = {
        recommend_goods_id,
        sort
      };
      this.axios
        .post('platform/shop/saveRecommendGoodsSort', data)
        .then((res) => {
          this.$message.success('修改成功');
          this.getList();
        })
        .catch((err) => {
          console.log(err);
          this.getList();
        });
    },
    //选择商品
    checkGoods(goods) {
      console.log(goods);
      let goods_arr = goods.map((item) => {
        return item.goods_id;
      });
      let data = {
        recommend_id: 1,
        keyword_id: 0,
        goods_ids: goods_arr.toString()
      };
      this.axios
        .post('platform/shop/addRecommendGoods', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('商品添加成功');
            this.getList();
            this.chooseGoodShow = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.getList();
        });
    },
    //删除商品
    delGoods(recommend_goods_id) {
      this.$confirm('确定删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/shop/delRecommendGoods', { recommend_goods_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('商品已删除');
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  text-align: left;
}
.topbpx {
  display: flex;
  align-items: flex-end;
  margin-bottom: 20px;
}
.title {
  font-size: 18px;
  font-weight: 700;
  margin-left: 30px;
}
.outstate {
  width: 80px;
  text-align: center;
  color: #ff7430;
  border: 2px solid #ff7430;
  border-radius: 3px;
  font-weight: 700;
}
</style>